/**
 *
 * Icon
 *
 */
import React, { memo, useEffect, useState, useRef } from 'react';

import { Wrapper } from './styles';

interface Props {
  icon: string;
  onClick?: () => void;
  height?: string;
  width?: string;
  color?: string;
  mr?: string | number;
  ml?: string | number;
  mt?: string | number;
  mb?: string | number;
  cursor?: string;
}

export const Icon = memo(({ icon, onClick, height = '16px', width = '16px', color, mr, ml, mt, mb, cursor }: Props) => {
  const ImportedIconRef = useRef<React.FC<React.SVGProps<SVGSVGElement>>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const importIcon = async () => {
      try {
        const { default: namedImport } = await import(`!!@svgr/webpack?-svgo,+titleProp,+ref!assets/icons/${icon}.svg`);
        ImportedIconRef.current = namedImport;
        if (isMounted) setLoading(false);
      } catch (err) {
        throw err;
      }
    };
    importIcon();
  }, [icon]);

  if (!loading && ImportedIconRef.current) {
    const { current: ImportedIcon } = ImportedIconRef;
    return (
      <Wrapper
        height={height}
        width={width}
        mr={mr}
        ml={ml}
        mt={mt}
        mb={mb}
        onClick={onClick}
        cursor={cursor}
        color={color}
      >
        <ImportedIcon />
      </Wrapper>
    );
  }

  return null;
});
